import api from "@/api";

export async function loadOrgTheme() {
  try {
    const token = localStorage.getItem("token") || "";
    const payload = token ? JSON.parse(atob(token.split(".")[1])) : {};
    const orgId = payload.org;
    if (!orgId) {
      localStorage.removeItem("orgInfo");
      return null;
    }
    const r = await api.get(`/orgs/by-id/${orgId}`);
    const org = r.data || {};
    
    // Make logo_url absolute if it's relative
    if (org.logo_url && org.logo_url.startsWith("/")) {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
      org.logo_url = backendUrl + org.logo_url;
    }
    
    // Apply CSS variables
    const t = org.theme || { primary: "#0a2a66", primaryText: "#ffffff", secondary: "#ffffff", secondaryText: "#0a2a66", bg: "#ffffff", text: "#000000" };
    const root = document.documentElement;
    root.style.setProperty("--brand-bg", t.bg);
    root.style.setProperty("--brand-text", t.text);
    root.style.setProperty("--brand-primary", t.primary);
    root.style.setProperty("--brand-primary-text", t.primaryText);
    root.style.setProperty("--brand-secondary", t.secondary);
    root.style.setProperty("--brand-secondary-text", t.secondaryText);
    localStorage.setItem("orgInfo", JSON.stringify(org));
    try { window.dispatchEvent(new CustomEvent("orgInfoUpdated", { detail: org })); } catch {}
    return org;
  } catch (e) {
    localStorage.removeItem("orgInfo");
    return null;
  }
}

export function getOrgInfo() {
  try { return JSON.parse(localStorage.getItem("orgInfo")||"null"); } catch { return null; }
}
